import { FormattedMessage } from 'react-intl';
import { getEnv } from 'env/env';
import { Hyperlink } from './hyperlink';

export const SupportLink = () => (
  <Hyperlink destination={getEnv('NEXT_PUBLIC_EDX_SUPPORT_URL')}>
    <FormattedMessage
      id="checkout.error.fallback.support.link"
      defaultMessage="contact support"
      description="The support link as in 'please {contact support}'"
    />
  </Hyperlink>
);
